import React, { useMemo, useState, useRef } from 'react'

import { useEffect } from 'react';

import { useSelector, useDispatch } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import TableContainer from '../../components/Common/TableContainer';
// import { API_URL } from 'helpers/url_helper';
import axios from 'axios'


import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
  Button
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";


import { Menu_Name,Module_Code, Module_Name, Module_Description, Module_Route, Sub_Name } from './module-rolelistCol';

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import './icon-dropdown.css'; 
import Select from 'react-select';
import {RoleList,AccessRights,Modules,Module_Menu} from "common/data/constants"
import CustomSelect from 'components/Common/custom-select';
import { useAuthUserDetails } from 'components/Common/getAuthUserDetails';
import { deleteModule, fetchModules, saveApplicationModuleDetails } from 'store/actions';
import Swal from 'sweetalert2';
import Loader from 'common/pageLoader';
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";

function Module() {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const {
    modulesList,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    modulesList: state.LoginCreation?.modulesList ?? [],

    loading: state.LoginCreation?.loading,
    error: state.LoginCreation?.error,
    success: state.LoginCreation?.success,
  }));

  const [moduleData, setModuleData] = useState([]);
  const [modules, setModules] = useState();  
  const [Id, setId] = useState(0);
  const [modulelist, setModulelist] = useState([]);
  const [modal, setModal] = useState(false);
  const history = useHistory();
  const [isTyping, setIsTyping] = useState(false);
  const [selectedGroup, setselectedGroup] = useState(null);
  const optionGroup = [
    {
      label: "Font awesome Icons",
      options: [
        { label: <i className="bx bxs-dashboard"><span> Dashboard</span></i>, value: "bx bxs-dashboard" },
        { label: <i className="bx bx-user-circle"><span> User</span></i>, value: "bx bx-user-circle" },
      ]
    },
    {
      label: "Material Icons",
      options: [
        { label: "Tent", value: "Tent" },
        { label: "Flashlight", value: "Flashlight" },
        { label: "Toilet Paper", value: "Toilet Paper" }
      ]
    }
  ];


  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchModules(unitId));
  }, [dispatch]);

  useEffect(() => {
    if (modulesList?.length) {
      setModuleData(modulesList);
    }else{
      setModuleData([])
    }
  }, [modulesList]);

  useEffect(() => {
    if (success) {
      dispatch(fetchModules(authDetails?.unit_id));
      handleReset()
    }
  }, [authDetails, success, dispatch]);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      module_name: "",
      module_description: "",
      module_route:  "",
      module_icon: "",
      main_menu: "",
      sub_menu: "",
    },

    validationSchema: Yup.object({
      module_name: Yup.string().trim().required("Please enter Module Name"),
      module_route: Yup.string().trim().required("Please enter Module Route"),
      main_menu: Yup.string().required("Please select a Main Menu"),

      // sub_menu: Yup.string().when("main_menu", {
      //   is: (main_menu) => {
      //     const selectedMenu = Module_Menu.find(
      //       (menu) => menu.title === main_menu
      //     );
      //     return !!selectedMenu?.children?.length;
      //   },
      //   then: (schema) => schema.required("Please select a Sub Menu"),
      //   otherwise: (schema) => schema.notRequired(),
      // }),
    }),

    onSubmit: async (values) => {
      const formData = new FormData();
      formData.append("_id", Id || 0);
      // formData.append("module_code", values.module_code || "");
      formData.append("module_name", values.module_name || "");
      formData.append("module_route", values.module_route || "");
      formData.append("module_icon", values.module_icon || "");
      formData.append("main_menu", values.main_menu || "");
      formData.append("sub_menu", values.sub_menu || "");
      formData.append("create_by", authDetails?.user_id || "");
      formData.append("role_id", 0);

      dispatch(saveApplicationModuleDetails(formData));
    },
  });
 
  const [isEdit, setIsEdit] = useState(false);
  const [accessCondition, setAccessCondition] = useState([]);


  const handleInputChange = (inputValue) => {
    // This function will be called whenever user types in the select textbox
    if (inputValue) {
      setIsTyping(true); // User is typing
    } else {
      setIsTyping(false); // User has cleared input
    }
  //Access Rights
  }

  const handleSelectGroup = (selectedGroup) => {
    console.log(selectedGroup);
    setselectedGroup(selectedGroup);
  }

//   const getModuleAccessRight = () =>{
//     const accessData = getModuleAccess(moduleList.module);    
//     const getlist = accessData.data;
//     setAccessCondition(getlist)   
//     if(accessData && (accessData.data.read_access == 0 &&  accessData.data.create_access == 0 && accessData.data.edit_access == 0 && accessData.data.delete_access == 0)) {
//       history.push('/unAuthorized')
//     }
// }

// useEffect(()=>{
//   getModuleAccessRight();
// },[])

  // const columns = useMemo(
    
  //   () => [
  //     {
  //       Header: "Action",
  //       Cell: cellProps => {
  //         return (
  //           <div className="d-flex gap-3">                    
  //             {/* {accessCondition.edit_access === 1 && ( */}
  //               <Link
  //               to="#"
  //               className="text-success"
  //               onClick={() => {
  //                 const moduledatas = cellProps.row.original;
  //                 handleModuleClick(moduledatas);
  //               }}
  //             >
  //               <i className="bx bxs-edit font-size-18" id="edittooltip" />
  //               <UncontrolledTooltip placement="top" target="edittooltip">
  //                 Edit
  //               </UncontrolledTooltip>
  //             </Link>
  //           {/* )}
              
  //             {accessCondition.delete_access === 1 &&  */}
  //             <Link
  //               to="#"
  //               className="text-danger"
  //               onClick={() => {
  //                 const moduledatas = cellProps.row.original;
  //                 onClickDelete(moduledatas);
  //               }}
  //             >
  //               <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
  //               <UncontrolledTooltip placement="top" target="deletetooltip">
  //                 Delete
  //               </UncontrolledTooltip>
  //             </Link>
  //             {/* } */}
              
  //           </div>
  //         );
  //       },
  //     },
  //     {
  //       Header: "S.No",
  //       Cell: ({ row }) => moduleData.length - row.index,
  //       className: "serial-no",
  //       applyHeaderClass: true,
  //     },
  //     {
  //       Header: 'Module Name',
  //       accessor: 'module_name',
  //       filterable: true,
  //       Cell: cellProps => {
  //         return <Module_Name  {...cellProps} />;
  //       },
  //     },
  //     {
  //       Header: 'Main Menu',
  //       accessor: 'main_menu',
  //       filterable: true,
  //       Cell: cellProps => {
  //         return <Menu_Name  {...cellProps} />;
  //       },
  //     },
  //      {
  //       Header: 'Sub Menu',
  //       accessor: 'sub_menu',
  //       filterable: true,
  //       Cell: cellProps => {
  //         return <Sub_Name  {...cellProps} />;
  //       },
  //     },
  //     // {
  //     //   Header: 'Code',
  //     //   accessor: 'module_code',
  //     //   filterable: true,
  //     //   Cell: cellProps => {
  //     //     return <Module_Code {...cellProps} />;
  //     //   },
  //     // },
  //     // {
  //     //   Header: 'Module Description',
  //     //   accessor: 'module_description',
  //     //   filterable: true,
  //     //   Cell: cellProps => {
  //     //     return <Module_Description  {...cellProps} />;
  //     //   },
  //     // },
  //     {
  //       Header: 'Module Route',
  //       accessor: 'module_route',
  //       filterable: true,
  //       Cell: cellProps => {
  //         return <Module_Route  {...cellProps} />;
  //       },
  //     },   
      
  //   ],
  //   [moduleData,accessCondition.edit_access, accessCondition.delete_access]
  // );

  const showActionColumn = canEdit || canDelete;

const actionColumn = {
  Header: "Action",
  Cell: cellProps => {
    const rowData = cellProps.row.original;

    return (
      <div className="d-flex gap-3">
        {canEdit && (
          <Link
            to="#"
            className="text-success"
            onClick={() => handleModuleClick(rowData)}
          >
            <i className="bx bxs-edit font-size-18" id="edittooltip" />
            <UncontrolledTooltip placement="top" target="edittooltip">Edit</UncontrolledTooltip>
          </Link>
        )}

        {canDelete && (
          <Link
            to="#"
            className="text-danger"
            onClick={() => onClickDelete(rowData)}
          >
            <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
            <UncontrolledTooltip placement="top" target="deletetooltip">Delete</UncontrolledTooltip>
          </Link>
        )}
      </div>
    );
  },
};

const columns = useMemo(() => {
  const baseColumns = [
    {
      Header: "S.No",
      Cell: ({ row }) => moduleData.length - row.index,
      className: "serial-no",
      applyHeaderClass: true,
    },
    {
      Header: 'Module Name',
      accessor: 'module_name',
      filterable: true,
      Cell: cellProps => <Module_Name {...cellProps} />,
    },
    {
      Header: 'Main Menu',
      accessor: 'main_menu',
      filterable: true,
      Cell: cellProps => <Menu_Name {...cellProps} />,
    },
    {
      Header: 'Sub Menu',
      accessor: 'sub_menu',
      filterable: true,
      Cell: cellProps => <Sub_Name {...cellProps} />,
    },
    {
      Header: 'Module Route',
      accessor: 'module_route',
      filterable: true,
      Cell: cellProps => <Module_Route {...cellProps} />,
    },
  ];

  return showActionColumn ? [actionColumn, ...baseColumns] : baseColumns;
}, [moduleData, canEdit, canDelete]);


  
    //GetAll Module
 
  // const getModules = () => {
  //   let rec = fetch(API_URL + "api/allapimodule").then(resp => resp.json()).then(resp => {
  //     const decryptdata = decryptData(resp)
  //     console.log(decryptdata)
  //     const getmodulelist = JSON.parse(decryptdata)
  //     console.log(getmodulelist)
  //     setModuleData(getmodulelist)
  //     setModules(moduleData);
  //     console.log(rec)
  //   })
  // }



  useEffect(() => {
    // getModules()
    setIsEdit(false);
  }, []);
  

  const toggle = () => {   
    if (modal) {
      setModal(false);
      setModules(null);
    } else {
      setModal(true);
    }
  };

  const handleModuleClick = arg => {
    // debugger
    const modlist = arg;
    console.log(modlist)
    setId(modlist._id)
    setModules({
      id: modlist._id,
      main_menu: modlist.main_menu,
      sub_menu: modlist.sub_menu,
  //  module_code: modlist.module_code,
    module_name: modlist.module_name,
    module_description: modlist.module_description,
    module_route: modlist.module_route
    });
    validation.setFieldValue("module_name", modlist.module_name);
    validation.setFieldValue("main_menu", modlist.main_menu);
    validation.setFieldValue("sub_menu", modlist.sub_menu);
    validation.setFieldValue("module_route", modlist.module_route);
    validation.setFieldValue("module_icon", modlist.module_icon);
    setSelectedIcon(iconOptions.find(item => item.value === modlist.module_icon));
    setIsEdit(true);    
    toggle();
  };

  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = modulelists => {
    console.log(modulelists)
    setId(modulelists._id)
   // setModules(modulelists);
    setDeleteModal(true);
  };

  const handleDeleteModule = () => {
    const formData = new FormData();
    formData.append("_id", Id);
    formData.append("create_by", authDetails?.user_id || "");
    dispatch(deleteModule(formData));

    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleModuleClicks = () => {
    setModulelist("");
    setIsEdit(false);
    toggle();
  };


  const [selectedIcon, setSelectedIcon] = useState(null);

  const iconOptions = [
    { value: 'bx bx-cog', label: 'Cog', icon: <i className="bx bx-cog"></i> },
    { value: 'bx bx-book', label: 'Book', icon: <i className="bx bx-book"></i> },
    { value: 'bx bx-plus', label: 'Plus', icon: <i className="bx bx-plus"></i> },
    { value: 'bx bx-brain', label: 'Brain', icon: <i className="bx bx-brain"></i> },
    { value: 'bx bx-search', label: 'Search', icon: <i className="bx bx-search"></i> },
    { value: 'bx bx-check-circle', label: 'Check Circle', icon: <i className="bx bx-check-circle"></i> },
    { value: 'bx bx-briefcase', label: 'Briefcase', icon: <i className="bx bx-briefcase"></i> },
    { value: 'bx bx-loader', label: 'Loader', icon: <i className="bx bx-loader"></i> },
    { value: 'bx bx-calendar', label: 'Calendar', icon: <i className="bx bx-calendar"></i> },
    { value: 'bx bx-id-card', label: 'ID Card', icon: <i className="bx bx-id-card"></i> },
    { value: 'bx bx-data', label: 'Data', icon: <i className="bx bx-data"></i> },
    { value: 'bx bx-list-ul', label: 'List', icon: <i className="bx bx-list-ul"></i> },
    { value: 'bx bx-card', label: 'Card', icon: <i className="bx bx-card"></i> },
    { value: 'mdi mdi-shield-account-outline', label: 'Shield Account', icon: <i className="mdi mdi-shield-account-outline"></i> },
    { value: 'bx bx-lock', label: 'Lock', icon: <i className="bx bx-lock"></i> },
    { value: 'bx bx-map', label: 'Map', icon: <i className="bx bx-map"></i> },
    { value: 'mdi mdi-certificate-outline', label: 'Certificate', icon: <i className="mdi mdi-certificate-outline"></i> },
    { value: 'bx bx-package', label: 'Package', icon: <i className="bx bx-package"></i> }
  ];

  const handleChangeIcon = selectedOption => {
    setSelectedIcon(selectedOption);
  };

  const handleMainMenuChange = (selectedOption) => {
    validation.setFieldValue("main_menu", selectedOption?.title || "");
    validation.setFieldValue("sub_menu", "");
  };
  
  const handleSubMenuChange = (selectedOption) => {
    validation.setFieldValue("sub_menu", selectedOption?.title || "");
  };

  const handleReset = () => {
    validation.handleReset();       
    setIsEdit(false);            
    setId(0);             
  };

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteModule}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Loader loading={loading}/>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Configuration" breadcrumbItem="Module" />
          {(canEdit || canCreate) && (
            <Card>
              <CardBody>
                <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <Row form>
                      {/* 🟢 Module Name */}
                      <Col md="3" sm="6" xs="12">
                        <div className="mb-3">
                          <Label className="form-label">Module Name <span className="text-danger">*</span></Label>
                          <Input
                            name="module_name"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.module_name || ""}
                            invalid={
                              validation.touched.module_name && validation.errors.module_name
                                ? true
                                : false
                            }
                          />
                          {validation.touched.module_name && validation.errors.module_name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.module_name}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>

                      {/* 🟢 Main Menu */}
                      <Col md="3" sm="6" xs="12">
                        <Label className="form-label">
                          Main Menu <span className="text-danger">*</span>
                        </Label>
                        <CustomSelect
                          name="main_menu"
                          options={Module_Menu.map(menu => ({
                            value: menu.title,
                            label: menu.title,
                          }))}
                          value={
                            validation.values.main_menu
                              ? { value: validation.values.main_menu, label: validation.values.main_menu }
                              : null
                          }
                          onChange={(selectedOption) => {
                            const selectedValue = selectedOption ? selectedOption.value : "";
                            validation.setFieldValue("main_menu", selectedValue);
                            validation.setFieldValue("sub_menu", ""); // reset sub menu
                          }}
                          onBlur={validation.handleBlur}
                          placeholder="Select Main Menu..."
                          invalid={
                            validation.touched.main_menu && validation.errors.main_menu
                              ? true
                              : false
                          }
                        />
                        {validation.touched.main_menu && validation.errors.main_menu && (
                          <div className="text-danger">{validation.errors.main_menu}</div>
                        )}
                      </Col>

                      {/* 🟢 Sub Menu (Conditional) */}
                      {Module_Menu.find(menu => menu.title === validation.values.main_menu)?.children?.length > 0 && (
                        <Col md="3" sm="6" xs="12">
                          <Label className="form-label">
                            Sub Menu
                          </Label>
                          <CustomSelect
                            name="sub_menu"
                            options={
                              Module_Menu.find(menu => menu.title === validation.values.main_menu)?.children.map(sub => ({
                                value: sub.title,
                                label: sub.title,
                              })) || []
                            }
                            value={
                              validation.values.sub_menu
                                ? { value: validation.values.sub_menu, label: validation.values.sub_menu }
                                : null
                            }
                            onChange={(selectedOption) => {
                              const selectedValue = selectedOption ? selectedOption.value : "";
                              validation.setFieldValue("sub_menu", selectedValue);
                            }}
                            onBlur={validation.handleBlur}
                            placeholder="Select Sub Menu..."
                          />
                          {validation.touched.sub_menu && validation.errors.sub_menu && (
                            <div className="text-danger">{validation.errors.sub_menu}</div>
                          )}
                        </Col>
                      )}

                      {/* 🟢 Module Description */}
                      {/* <Col md="3" sm="6" xs="12">
                        <div className="mb-3">
                          <Label className="form-label">Module Description <span className="text-danger">*</span></Label>
                          <Input
                            name="module_description"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.module_description || ""}
                            invalid={
                              validation.touched.module_description &&
                              validation.errors.module_description
                                ? true
                                : false
                            }
                          />
                          {validation.touched.module_description &&
                          validation.errors.module_description ? (
                            <FormFeedback type="invalid">
                              {validation.errors.module_description}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col> */}

                      {/* 🟢 Module Route */}
                      <Col md="3" sm="6" xs="12">
                        <div className="mb-3">
                          <Label className="form-label">Module Route <span className="text-danger">*</span></Label>
                          <Input
                            name="module_route"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.module_route || ""}
                            invalid={
                              validation.touched.module_route && validation.errors.module_route
                                ? true
                                : false
                            }
                          />
                          {validation.touched.module_route &&
                          validation.errors.module_route ? (
                            <FormFeedback type="invalid">
                              {validation.errors.module_route}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>

                      {/* 🟢 Module Icon */}
                      <Col md="3" sm="6" xs="12">
                        <div className="mb-3">
                          <Label className="form-label">Module Icon</Label>
                          <CustomSelect
                            name="module_icon"
                            options={iconOptions}
                            isSearchable
                            value={
                              iconOptions.find(opt => opt.value === validation.values.module_icon) || null
                            }
                            onChange={(selectedOption) => {
                              validation.setFieldValue("module_icon", selectedOption ? selectedOption.value : "");
                              setSelectedIcon(selectedOption || null);
                            }}
                            onBlur={validation.handleBlur}
                            placeholder="Select Icon..."
                            
                            // 🧩 This is the key part to render icons with labels
                            formatOptionLabel={(option) => (
                              <div className="d-flex align-items-center gap-2">
                                {option.icon}
                                <span>{option.label}</span>
                              </div>
                            )}
                          />

                          {/* ✅ Show selected icon preview */}
                          {/* {selectedIcon && (
                            <div className="mt-2 text-muted d-flex align-items-center gap-2">
                              <span className="fs-5">{selectedIcon.icon}</span>
                              <span>{selectedIcon.label}</span>
                            </div>
                          )} */}

                          {/* ⚠️ Optional validation message if required */}
                          {validation.touched.module_icon && validation.errors.module_icon && (
                            <div className="text-danger">{validation.errors.module_icon}</div>
                          )}
                        </div>
                      </Col>
                      <Col className="d-flex mob-center align-items-center justify-content-end mt-2">
                        <Button type="submit" className="btn button-save me-2">
                          <i className="fas fa-save me-1" /> {isEdit ? "Update" : "Save"}
                        </Button>
                        <Button
                          type="button"
                          onClick={handleReset}
                          className="btn button-cancel"> <i className="fas fa-sync me-1" /> Cancel
                        </Button>
                      </Col>
                    </Row>
                  </Form>

              </CardBody>
            </Card>
          )}
         
            <Card>
              <CardBody>
              
              
                  <TableContainer
                    columns={columns}
                    data={moduleData && moduleData.length > 0 ? moduleData : []}
                    isGlobalFilter={true}                                         
                    // isAddModuleList={accessCondition && accessCondition.create_access === 1 ? true : false}  
                    // isAddModuleList={true}                   
                    // handleModuleClick={handleModuleClicks}
                    customPageSize={10}
                    className="custom-header-css"                      
                  />
              </CardBody>
            </Card>
        </Container>
      </div>
    </React.Fragment>
  );
}


export default Module;